export const API_URL = process.env.REACT_APP_API_URL;

export const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
});

export const toNum = (v, digits = 2) => {
  if (v === '' || v === null || typeof v === 'undefined') return null;
  const n = Number(String(v).replace(',', '.'));
  return Number.isNaN(n) ? null : Number(n.toFixed(digits));
};
